<div class="accordian-row cursor accordian-row-animate" [ngClass]="(customer.deviceId && (selectedCustomerID == customer.deviceId)) || (customer.customer_id && (selectedCustomerID == customer.customer_id)) ? 'active' : ''" (click) = "togglePanel(index)" >
  <div fxLayout="row">
    <div class="accordian-flex" fxFlex="70"
    [matTooltip] = "customer?.customer_name ? customer?.customer_name : customer?.newPrinterName"
    [matTooltipDisabled] = "customerColumn?.scrollWidth <= customerColumn?.clientWidth"
    matTooltipClass="mat-customer-tooltip top"  loading="lazy"   [matTooltipPosition]="'above'"
    #tooltip="matTooltip"
    >
      <span class="person-img">
        <img *ngIf="customer?.customer_type == 'vip'" src="./assets/icons/vip_customer.svg" alt="star-person">
        <img *ngIf="customer?.customer_type !== 'vip' && this.customer.customer_type" src="./assets/icons/normal.svg" alt="person">
      </span>
      <span  class="customerName" [ngClass] = "accordianClass(customer)"  #customerColumn>
        {{customer?.customer_name ? customer?.customer_name : customer?.newPrinterName}}
      </span>

      <!-- <span *ngIf = "customer?.printer_name" class="customerName"  #printerColumn>
        {{customer?.printer_name}}
       </span> -->
    </div>
    <div class="accordian-flexitem" fxFlex="30">
      <div class="flex-end accordian-end">

        <span class="case_count" *ngIf="customer?.low_ink_count > 0"> {{customer?.low_ink_count}}</span>
        <span class="image-layer" *ngIf="customer?.low_ink_count > 0"> <img class="action-img" src="./assets/icons/low_ink.svg" alt="low-ink-level"></span> 

        <span class="case_count" *ngIf="customer?.alerts_count > 0"
          [matTooltip] = "customer?.alerts_count"
          [matTooltipDisabled] = "alertCount?.scrollWidth <= alertCount?.clientWidth"
          matTooltipClass="mat-customer-tooltip top"  loading="lazy"   [matTooltipPosition]="'above'"
          #tooltip="matTooltip"
          #alertCount
          >{{customer?.alerts_count}}
        </span>

        <span class="image-layer no-action-req" *ngIf="customer?.alerts_count > 0"  [ngClass]="customer?.customer_status == 'no action required' ? 'no-action-req' : 'action-req'">
          <img *ngIf="customer?.customer_status == 'no action required'" src="./assets/icons/no_action_req.svg" alt="no-action-required">
          <img *ngIf="customer?.customer_status !== 'no action required'" src="./assets/icons/action_req.svg" alt="action-required">
        </span>

        <span class="case_count" *ngIf="customer?.alerts_count1 > 0"
          [matTooltip] = "customer?.alerts_count1"
          [matTooltipDisabled] = "alertCount1?.scrollWidth <= alertCount1?.clientWidth"
          matTooltipClass="mat-customer-tooltip top"  loading="lazy"   [matTooltipPosition]="'above'"
          #tooltip="matTooltip"
          #alertCount1
          >{{customer?.alerts_count1}}</span>


        <span class="image-layer no-action-req" *ngIf="customer?.alerts_count1 > 0" [ngClass]="customer?.customer_status == 'no action required' ? 'no-action-req' : 'action-req'">
          <img *ngIf="customer?.customer_status !== 'no action required'" src="./assets/icons/no_action_req.svg" alt="no-action-required">
        </span>
        <span class="drop-down-toggle-btn flex-center">
          <img class="move-right" src="./assets/icons/arrow-right-primary.svg" alt="expand">
        </span>
      </div>
    </div>
  </div>
</div>
